import { CasButton, CasStackRow } from 'src/compass/shared/components';
import Iconify from 'src/components/iconify';
import useUpdateMutation from 'src/compass/shared/hooks/reactQuery/useUpdateMutation';
import { onSuccessEnqueueSnackbar } from 'src/compass/shared/util/onSuccessEnqueueSnackbar';
import { getRelativeTime } from 'src/compass/shared/util/casMoment';
import useCasBoolean from 'src/compass/shared/hooks/useCasBoolean';
import { IGeneralObjectType } from 'src/compass/site/util';

interface CheckoutActionButtonProps {
  onUpdated: Function;
  data: IGeneralObjectType;
}

export function ClaimCheckoutActionButton({ onUpdated, data }: CheckoutActionButtonProps) {
  const { id: endorsementId, claimCheckedOutDate, checkedOut, checkedOutToCurrentUser } = data;

  const dialog = useCasBoolean();

  const { mutate } = useUpdateMutation({
    url: '/Sce/Claims/Checkout',
    onSuccess: (response) => {
      onSuccessEnqueueSnackbar(response);
      dialog.setFalse();
      onUpdated();
    },
  });

  const handleCheckoutClick = () => mutate({ endorsementId, action: 'Update' });

  const handleCheckinClick = () => mutate({ endorsementId, action: 'Clear' });

  if (claimCheckedOutDate)
    return (
      <CasStackRow alignItems="center">
        <div style={{ backgroundColor: checkedOutToCurrentUser ? 'palegoldenrod' : 'yellow' }}>
          Checked out to <b>{checkedOut}</b> {getRelativeTime(claimCheckedOutDate)}
        </div>
        <CasButton
          startIcon={<Iconify icon="material-symbols:login" />}
          color="error"
          variant="text"
          size="small"
          onClick={handleCheckinClick}
        >
          Checkin
        </CasButton>
      </CasStackRow>
    );

  return (
    <CasButton
      startIcon={<Iconify icon="material-symbols:logout" />}
      variant="text"
      size="small"
      onClick={handleCheckoutClick}
    >
      Checkout
    </CasButton>
  );
}
